import { useState, useEffect } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Link2 } from "lucide-react";

export default function UnlinkedProductsPage() {
  const [products, setProducts] = useState([]);
  const [brands, setBrands] = useState([]);
  const [selected, setSelected] = useState({});

  useEffect(() => {
    api.get("/brands/unlinked-products").then(r => setProducts(r.data)).catch(e => toast.error("Failed to load"));
    api.get("/brands/options?live_only=true").then(r => setBrands(r.data)).catch(() => {});
  }, []);

  const link = async (productId) => {
    const brandId = selected[productId];
    if (!brandId) { toast.error("Select a brand"); return; }
    try {
      const brand = brands.find(b => b._id === brandId);
      await api.post(`/brands/${brandId}/link-product`, { product_id: productId });
      toast.success(`Linked to ${brand?.display_name}`);
      setProducts(prev => prev.filter(p => p.product_id !== productId));
    } catch (e) { toast.error(e.response?.data?.detail || "Link failed"); }
  };

  return (
    <div className="space-y-4" data-testid="unlinked-products-page">
      <h1 className="text-xl font-bold"><Link2 className="w-5 h-5 inline mr-1" /> Unlinked Products ({products.length})</h1>
      <p className="text-xs text-zinc-500">Catalogue products without a brand. Link them to a live brand.</p>
      {products.length === 0 ? <p className="text-sm text-zinc-400 py-8 text-center">All products are linked.</p> : (
        <div className="space-y-2">
          {products.map(p => (
            <div key={p._id} className="border rounded-md p-3 flex items-center justify-between" data-testid={`unlinked-${p.product_id}`}>
              <div>
                <span className="font-medium text-sm">{p.name}</span>
                <span className="ml-2 text-xs text-zinc-500">{p.product_id}</span>
                {p.brand && <span className="ml-2 text-xs text-amber-600">Brand text: {p.brand}</span>}
              </div>
              <div className="flex items-center gap-2">
                <select className="h-7 text-xs border rounded-md px-1" value={selected[p.product_id] || ""} onChange={e => setSelected({...selected, [p.product_id]: e.target.value})}>
                  <option value="">Select brand...</option>
                  {brands.map(b => <option key={b._id} value={b._id}>{b.display_name}</option>)}
                </select>
                <Button size="sm" onClick={() => link(p.product_id)}>Link</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
